export default __webpack_public_path__ + "static/exercise_red-788c5609685d3dd5b641b1d59d9f7aad.jpg";